"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePoolRequest = exports.encodePoolRequest = exports.encodePoolState = exports.decodePoolState = exports.isPoolState = exports.PoolRequest = exports.POOL_REQUEST_TAG = exports.InitializePoolRequest = exports.PoolAction = exports.Basket = exports.PoolState = exports.POOL_STATE_TAG = exports.ParamDesc = exports.AssetInfo = void 0;
const buffer_layout_1 = require("buffer-layout");
const borsh_1 = require("@project-serum/borsh");
const bn_js_1 = __importDefault(require("bn.js"));
exports.AssetInfo = buffer_layout_1.struct([
    borsh_1.publicKey('mint'),
    borsh_1.publicKey('vaultAddress'),
]);
exports.ParamDesc = buffer_layout_1.struct([
    borsh_1.publicKey('address'),
    borsh_1.bool('writable'),
]);
exports.POOL_STATE_TAG = new bn_js_1.default('16a7874c7fb2301b', 'hex');
exports.PoolState = borsh_1.tagged(exports.POOL_STATE_TAG, buffer_layout_1.struct([
    borsh_1.publicKey('poolTokenMint'),
    borsh_1.vec(exports.AssetInfo, 'assets'),
    borsh_1.publicKey('vaultSigner'),
    buffer_layout_1.u8('vaultSignerNonce'),
    borsh_1.vec(exports.ParamDesc, 'accountParams'),
    borsh_1.str('name'),
    borsh_1.publicKey('lqdFeeVault'),
    borsh_1.publicKey('initializerFeeVault'),
    buffer_layout_1.u32('feeRate'),
    borsh_1.option(borsh_1.publicKey(), 'adminKey'),
    borsh_1.vecU8('customState'),
]));
exports.Basket = buffer_layout_1.struct([borsh_1.vec(borsh_1.i64(), 'quantities')]);
exports.PoolAction = borsh_1.rustEnum([
    borsh_1.u64('create'),
    borsh_1.u64('redeem'),
    exports.Basket.replicate('swap'),
]);
exports.InitializePoolRequest = buffer_layout_1.struct([
    buffer_layout_1.u8('vaultSignerNonce'),
    buffer_layout_1.u8('assetsLength'),
    borsh_1.str('poolName'),
    buffer_layout_1.u32('feeRate'),
    borsh_1.vecU8('customData'),
]);
exports.POOL_REQUEST_TAG = new bn_js_1.default('220a6cbdcd1cc4cf', 'hex');
exports.PoolRequest = borsh_1.tagged(exports.POOL_REQUEST_TAG, borsh_1.rustEnum([
    exports.InitializePoolRequest.replicate('initialize'),
    exports.PoolAction.replicate('getBasket'),
    exports.PoolAction.replicate('execute'),
]));
function isPoolState(data) {
    return data.slice(0, 8).equals(exports.POOL_STATE_TAG.toBuffer('le'));
}
exports.isPoolState = isPoolState;
function decodePoolState(data) {
    return exports.PoolState.decode(data);
}
exports.decodePoolState = decodePoolState;
function encodePoolState(state) {
    const buffer = Buffer.alloc(1000);
    const len = exports.PoolState.encode(state, buffer);
    return buffer.slice(0, len);
}
exports.encodePoolState = encodePoolState;
function encodePoolRequest(poolRequest) {
    const buffer = Buffer.alloc(1000);
    const len = exports.PoolRequest.encode(poolRequest, buffer);
    return buffer.slice(0, len);
}
exports.encodePoolRequest = encodePoolRequest;
function decodePoolRequest(data) {
    return exports.PoolRequest.decode(data);
}
exports.decodePoolRequest = decodePoolRequest;
//# sourceMappingURL=schema.js.map